import StepConfirmation from './stepConfirmation';

export default StepConfirmation;
